import React, { useEffect, useState } from 'react';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';

const Example = () => {
    const [db, setDb] = useState([]); 
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    
    let url = `${BASE_API}user/all`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then(res => {
            if(!res.err) {
                setDb(res.users);
                setError(null);
            } else {
                setDb(null);
                setError(res);
            }
            setLoading(false);
        });
        
        console.log(db);
    }, [url]);

    return (
        <>
            {db.map((el, index) => <h4>{el.correo_electronico}</h4>)}
        </>
    );
}

export default Example;